import { Typography } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const MainTypography = styled(Typography)`
  margin-top: ${theme.padding.containerBig};
`;

export const TopMenuTitleTypography = styled(Typography)`
  color: ${theme.palette.logo.main};
  padding-left: ${theme.padding.content};
  font-weight: 600;
  font-size: ${theme.typography.fontSizeBig}px;
`;

export const ChapterTypography = styled(Typography)`
  margin: 50px;
  font-weight: 600;
`;

export const CardOptionTypography = styled(Typography)`
  font-weight: 600;
  // text-transform: uppercase;
`;

export const CardOptionDescriptionTypography = styled(Typography)`
  margin: 0 #{theme.padding.content};
`;

export const ModalTypography = styled(Typography)`
  margin-bottom: 10px;
`;

export const TitleTypography = styled(Typography)`
  margin: ${theme.padding.section} 0;
`;

export const BreadCrumbTypography = styled(Typography)`
  font-size: ${theme.typography.fontSize}px;
  margin-top: 3px;
`;

export const FormHintTypography = styled(Typography)`
  font-size: ${theme.typography.fontSizeSmall}px;
  color: ${theme.palette.text.secondary};
  margin-bottom: ${theme.padding.content};
`;

export const DescriptionTypography = styled(Typography)`
  color: ${theme.palette.text.secondary};
  padding-right: ${theme.padding.small};
  parring-top: ${theme.padding.small};
  display: inline-block;
`;

export const SecretTypography = styled(Typography)`
  font-size: ${theme.typography.fontSizeSmall}px;
  color: ${theme.palette.text.secondary};
`;

export const SectionEyebrow = styled(Typography)`
  font-size: ${theme.typography.fontSize}px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${theme.palette.primary.main};
  margin-bottom: 12px;
`;

